import { useTranslation } from "react-i18next";
import logoHorizontal from "Assets/images/LogoBaipro.svg";

// Component
import Socials from "Components/Socials";

// Style
import "./Footer.scss";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="main-footer" data-testid="footer">
      <img
        src={logoHorizontal}
        alt="Logo Baipro"
        loading="lazy"
        className="logo"
        width={160}
        height={48}
      ></img>
      <div className="main">
        <div className="content">
          <p className="neocomplexx">Powered by Neocomplexx Group S.A.</p>
          <div className="content-links">
            <a href="/privacy" className="link">
              {t(`footer.terms`)}
            </a>
          </div>
        </div>
        <Socials />
      </div>
    </footer>
  );
};

export default Footer;
